module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RemindCustomerView.js"));
	}, "RemindCustomerView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RemindCustomerView!./src/pages/Promote/Schedule/NewAdd/RemindCustomer/RemindCustomerView.js
// module id = 1670
// module chunks = 418